import { render, staticRenderFns } from "./chemReviewInfo.vue?vue&type=template&id=0dc12272"
import script from "./chemReviewInfo.vue?vue&type=script&lang=js"
export * from "./chemReviewInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc12272')) {
      api.createRecord('0dc12272', component.options)
    } else {
      api.reload('0dc12272', component.options)
    }
    module.hot.accept("./chemReviewInfo.vue?vue&type=template&id=0dc12272", function () {
      api.rerender('0dc12272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/review/chemReviewInfo.vue"
export default component.exports